<template>
    <tr class="text-center">
      <td colspan="1000" class="">
        <span class="spinner-grow spinner-grow-sm"></span>
        <span class="spinner-grow spinner-grow-sm mx-2"></span>
        <span class="spinner-grow spinner-grow-sm"></span>
      </td>
    </tr>
</template>
<!-- ******************************************************** -->
<script>
  export default {
    name: 'LoadingRow',
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  